import { useSelector } from 'react-redux';

import { configSelectors } from '@config/core';
import { Role } from '@permissions/core';

export const useCurrentRole: () => Role = () => {
  const role: Role = useSelector(configSelectors.userRole);
  return role;
};
